enum InsuranceProductCategory {
  ANIMAL = 'ANIMAL',
  LIFE_AND_HEALTH = 'LIFE_AND_HEALTH',
  PROPERTY = 'PROPERTY',
  TRAVEL = 'TRAVEL',
  VEHICLE = 'VEHICLE',
}

export default InsuranceProductCategory;
